import { render, staticRenderFns } from "./choice-subject.vue?vue&type=template&id=595ae036&scoped=true&"
import script from "./choice-subject.vue?vue&type=script&lang=js&"
export * from "./choice-subject.vue?vue&type=script&lang=js&"
import style0 from "./choice-subject.vue?vue&type=style&index=0&id=595ae036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ae036",
  null
  
)

export default component.exports